import { render } from "./quiz-v1-question-option.vue?vue&type=template&id=dabc077c&scoped=true"
import script from "./quiz-v1-question-option.vue?vue&type=script&lang=js"
export * from "./quiz-v1-question-option.vue?vue&type=script&lang=js"

import "./quiz-v1-question-option.vue?vue&type=style&index=0&id=dabc077c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabc077c"]])

export default __exports__